import { Kiosk } from '@gozoki/api-types';
import { gozokiApiWithAuth } from '../gozokiApi';

export const fetchCheckoutKiosks = async (storeId: number) => {
    const response = await gozokiApiWithAuth.get<Kiosk[]>(`/stores/${storeId}/checkouts`);
    return response.data;
};
